import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/flow";

const SESSION_KEY = "flowlux_session_id";

function getSessionId() {
    let sid = "";
    try {
        sid = localStorage.getItem(SESSION_KEY) || "";
    } catch {
        // localStorage blocked — fall back to per-tab session
    }
    if (!sid) {
        sid =
            (typeof crypto !== "undefined" && crypto.randomUUID
                ? crypto.randomUUID()
                : `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
        try {
            localStorage.setItem(SESSION_KEY, sid);
        } catch {
            /* ignore */
        }
    }
    return sid;
}

async function send(event_type, extras = {}) {
    try {
        await api.post("/track", {
            event_type,
            path: typeof window !== "undefined" ? window.location.pathname + window.location.search : "",
            session_id: getSessionId(),
            referrer: typeof document !== "undefined" ? document.referrer || "" : "",
            ...extras,
        });
    } catch {
        // tracker is best-effort, never break the UX
    }
}

export function trackFormView(form_id, extras = {}) {
    send("form_view", { form_id, ...extras });
}

export function trackFormSubmit(form_id, extras = {}) {
    send("form_submit", { form_id, ...extras });
}

/** Drop this once near the top of your router; it auto-fires pageviews on every route change. */
export function AnalyticsRouteTracker() {
    const location = useLocation();
    useEffect(() => {
        send("pageview");
    }, [location.pathname, location.search]);
    return null;
}
